import { Text } from '@mantine/core';
import { IconMessageCircle } from '@tabler/icons-react';
import { match } from 'ts-pattern';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';
import type { AIDialogMessage } from '~/common/vm/protocol';

function getDialogTypeDisplayName(dialogType: AIDialogMessage['dialogType']): string {
  return match(dialogType)
    .with('alert', () => 'Alert')
    .with('confirm', () => 'Confirm')
    .with('prompt', () => 'Prompt')
    .with('beforeunload', () => 'Before Unload')
    .exhaustive();
}

function getDialogResponseDisplayValue(dialogType: AIDialogMessage['dialogType'], response?: string): string {
  return match(dialogType)
    .with('alert', () => 'OK')
    .with('confirm', () => 'OK')
    .with('prompt', () => (response !== undefined ? `"${response}"` : '""'))
    .with('beforeunload', () => 'OK')
    .exhaustive();
}

export function AIDialogCard({ message }: { message: Extract<AIMessage, { type: 'dialog' }> }) {
  return (
    <CollapsibleCard
      icon={IconMessageCircle}
      title="Dialog"
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <div className="rounded border border-gray-200 bg-gray-50 px-2 py-1 dark:border-gray-700 dark:bg-gray-800">
            <Text
              size="sm"
              className="font-medium"
            >
              {getDialogTypeDisplayName(message.dialogType)}
            </Text>
          </div>
          <Text
            size="sm"
            className="opacity-60"
          >
            →
          </Text>
          <div className="rounded border border-gray-200 bg-gray-50 px-2 py-1 dark:border-gray-700 dark:bg-gray-800">
            <Text
              size="sm"
              className="font-medium"
            >
              {getDialogResponseDisplayValue(message.dialogType, message.response)}
            </Text>
          </div>
        </div>
        {!!message.message && (
          <div className="rounded border border-gray-200 bg-white px-2 py-1.5 dark:border-gray-700 dark:bg-gray-900">
            <Text
              size="sm"
              className="text-gray-700 dark:text-gray-300"
            >
              {message.message}
            </Text>
          </div>
        )}
      </div>
    </CollapsibleCard>
  );
}
